var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotionDetectionOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9601 7.33268C13.6534 4.55268 11.4467 2.34602 8.66675 2.03935V0.666016H7.33341V2.03935C4.55341 2.34602 2.34675 4.55268 2.04008 7.33268H0.666748V8.66601H2.04008C2.34675 11.446 4.55341 13.6527 7.33341 13.9593V15.3327H8.66675V13.9593C11.4467 13.6527 13.6534 11.446 13.9601 8.66601H15.3334V7.33268H13.9601ZM8.00008 12.666C5.42008 12.666 3.33341 10.5793 3.33341 7.99935C3.33341 5.41935 5.42008 3.33268 8.00008 3.33268C10.5801 3.33268 12.6667 5.41935 12.6667 7.99935C12.6667 10.5793 10.5801 12.666 8.00008 12.666Z",
    fill: "#FF7600"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.33325,
    y: 0.666016,
    width: 1.33333,
    height: 14.6667,
    fill: "#FF7600"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    y: 7.33368,
    width: 14.6667,
    height: 1.33333,
    fill: "#FF7600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionDetectionOn);
export default __webpack_public_path__ + "static/media/motion-detection-on.d5de3085.svg";
export { ForwardRef as ReactComponent };